import React from 'react'
import ReactLoading from 'react-loading'
export default function LoadingFit() {
    return (
        <div className={`loading-fit`}>
            <ReactLoading type='bars' color='#009973' height={100 + '%'} width={200} />
        </div>
    )
}
